import React, { useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import { useFetchTutorialData } from '../../../api/helpdesk';
import Preloader from '../../Preloader';
import PaginationSection from '../PaginationSection';
import TutorialList from './TutorialList';

const Tutorial = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const { data: tutorials, isLoading } = useFetchTutorialData(currentPage);

  return (
    <Container fluid className="help-info bg-light">
      <Row>
        <h2 className="mb-3 mt-4">Tutorials</h2>
        <p className="text-muted mt-1">
          Printcart offers a comprehensive suite of print-on-demand services tailored
          to meet the diverse needs of businesses and individuals alike. Our platform
          provides a seamless experience, empowering users to effortlessly create,
          customize, and sell a wide range of print products.
        </p>
        {!!isLoading && (
          <div className="py-4">
            <Preloader />
          </div>
        )}
        {!isLoading && (
          <>
            <TutorialList datas={tutorials.data} />
            <PaginationSection
              currentPage={tutorials.meta.pagination.page}
              totalPages={tutorials.meta.pagination.pageCount}
              setCurrentPage={setCurrentPage}
            />
          </>
        )}
      </Row>
    </Container>
  );
};

export default Tutorial;
